export default "__VITE_ASSET__BAYtfezM__"